<template>
    <v-row>
        <v-col cols="12" sm="6">
            <v-text-field :label="datos.proposito === 'Venta y Arriendo' ? 'Abad / Arriendo' : 'Abad'"
                          :value="'APA10210'"
                          readonly>
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6" v-if="datos.proposito === 'Venta y Arriendo'">
            <v-text-field label="Abad / Venta"
                          :value="'APA10210'"
                          readonly>
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
            <v-text-field :label="datos.proposito === 'Venta y Arriendo' ? 'SIMI / Arriendo' : 'SIMI'"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" v-if="datos.proposito === 'Venta y Arriendo'">
            <v-text-field label="SIMI / Venta">
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
            <v-text-field :label="datos.proposito === 'Venta y Arriendo' ? 'Metro Cuadrado / Arriendo' : 'Metro Cuadrado'"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" v-if="datos.proposito === 'Venta y Arriendo'">
            <v-text-field label="Metro cuadrado / Venta">
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
            <v-text-field :label="datos.proposito === 'Venta y Arriendo' ? 'Finca Raíz / Arriendo' : 'Finca Raíz'"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" v-if="datos.proposito === 'Venta y Arriendo'">
            <v-text-field label="Finca raíz / Venta">
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
            <v-text-field :label="datos.proposito === 'Venta y Arriendo' ? 'Espacio Urbano / Arriendo' : 'Espacio Urbano'"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" v-if="datos.proposito === 'Venta y Arriendo'">
            <v-text-field label="Espacio urbano / Venta">
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
            <v-text-field :label="datos.proposito === 'Venta y Arriendo' ? 'Cien Cuadras / Arriendo' : 'Cien Cuadras'"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" v-if="datos.proposito === 'Venta y Arriendo'">
            <v-text-field label="Cien cuadras / Venta">
            </v-text-field>
        </v-col>

        <v-col cols="12">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="abadPrimary" @click="submit" dark>Continuar</v-btn>
            </v-card-actions>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      datos: state => state.realEstate.datos
    })
  },
  methods: {
    submit () {
      this.$emit('updateStateForm', true)
    }
  }
}
</script>
